import { IonButton, IonCol, IonInput, IonRow } from '@ionic/react';
import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { uppercaseFirstLetter } from '../../../util/string';
import Form from '../../common/Form';
import styled from 'styled-components';
import classNames from 'classnames';

const StyledForm = styled(Form)`
  width: 100%;
  padding: 0 24px;
`;
const ButtonRow = styled(IonRow)`
  margin-top: 8px;
  width: 100%;
`;

interface EmailFormProps {
  email: string;
  onSubmit: (values: { email: string }) => Promise<void>;
}

const EmailForm: React.FC<EmailFormProps> = ({ email, onSubmit }) => {
  const hasChanged = (values: { email: string }) => {
    return values.email !== email;
  };

  return (
    <Formik
      initialValues={{ email }}
      onSubmit={onSubmit}
      validateOnMount
      validationSchema={Yup.object({
        email: Yup.string().email().required(),
      })}
    >
      {({
        handleSubmit,
        isValid,
        errors,
        touched,
        isSubmitting,
        values,
        setFieldValue,
        setFieldTouched,
      }) => (
        <StyledForm onSubmit={handleSubmit}>
          <IonRow>
            <IonCol>
              <IonInput
                fill="outline"
                value={values.email}
                className={classNames({
                  ['ion-invalid']: errors.email,
                  ['ion-touched']: touched.email,
                })}
                label="Email Address"
                labelPlacement="floating"
                type="text"
                name="email"
                required
                onIonInput={(e) => {
                  setFieldValue('email', e.detail.value);
                  setFieldTouched('email', true);
                }}
                errorText={uppercaseFirstLetter(errors.email as string)}
              />
            </IonCol>
          </IonRow>
          <ButtonRow>
            <IonCol>
              <IonButton
                type="submit"
                disabled={
                  !isValid ||
                  isSubmitting ||
                  !touched.email ||
                  !hasChanged(values)
                }
                expand="block"
              >
                Save
              </IonButton>
            </IonCol>
          </ButtonRow>
        </StyledForm>
      )}
    </Formik>
  );
};

export default EmailForm;
